import { c as _c } from "react/compiler-runtime";
import React from "react";
const AiIcon = () => {
  const $ = _c(6);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M9.97075 5.577L10.573 7.2495C11.242 9.10575 12.7037 10.5675 14.56 11.2365L16.2325 11.8388C16.3832 11.8935 16.3832 12.1073 16.2325 12.1613L14.56 12.7635C12.7037 13.4325 11.242 14.8943 10.573 16.7505L9.97075 18.423C9.916 18.5738 9.70225 18.5738 9.64825 18.423L9.046 16.7505C8.377 14.8943 6.91525 13.4325 5.059 12.7635L3.3865 12.1613C3.23575 12.1065 3.23575 11.8928 3.3865 11.8388L5.059 11.2365C6.91525 10.5675 8.377 9.10575 9.046 7.2495L9.64825 5.577C9.70225 5.4255 9.916 5.4255 9.97075 5.577Z" fill="url(#paint0_linear_5666_4378)" />;
    t1 = <path d="M17.4993 1.55769L17.8045 2.40444C18.1435 3.34419 18.8838 4.08444 19.8235 4.42344L20.6703 4.72869C20.7468 4.75644 20.7468 4.86444 20.6703 4.89219L19.8235 5.19744C18.8838 5.53644 18.1435 6.27669 17.8045 7.21644L17.4993 8.06319C17.4715 8.13969 17.3635 8.13969 17.3358 8.06319L17.0305 7.21644C16.6915 6.27669 15.9513 5.53644 15.0115 5.19744L14.1648 4.89219C14.0883 4.86444 14.0883 4.75644 14.1648 4.72869L15.0115 4.42344C15.9513 4.08444 16.6915 3.34419 17.0305 2.40444L17.3358 1.55769C17.3635 1.48044 17.4723 1.48044 17.4993 1.55769Z" fill="url(#paint1_linear_5666_4378)" />;
    t2 = <path d="M17.4993 15.9375L17.8045 16.7843C18.1435 17.724 18.8838 18.4643 19.8235 18.8033L20.6703 19.1085C20.7468 19.1363 20.7468 19.2443 20.6703 19.272L19.8235 19.5773C18.8838 19.9163 18.1435 20.6565 17.8045 21.5963L17.4993 22.443C17.4715 22.5195 17.3635 22.5195 17.3358 22.443L17.0305 21.5963C16.6915 20.6565 15.9513 19.9163 15.0115 19.5773L14.1648 19.272C14.0883 19.2443 14.0883 19.1363 14.1648 19.1085L15.0115 18.8033C15.9513 18.4643 16.6915 17.724 17.0305 16.7843L17.3358 15.9375C17.3635 15.861 17.4723 15.861 17.4993 15.9375Z" fill="url(#paint2_linear_5666_4378)" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <linearGradient id="paint0_linear_5666_4378" x1="9.8095" y1="5.46338" x2="9.8095" y2="18.5361" gradientUnits="userSpaceOnUse"><stop stopColor="#608DFF" /><stop offset="1" stopColor="#0046F8" /></linearGradient>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <linearGradient id="paint1_linear_5666_4378" x1="17.4175" y1="1.49976" x2="17.4175" y2="8.12057" gradientUnits="userSpaceOnUse"><stop stopColor="#608DFF" /><stop offset="1" stopColor="#0046F8" /></linearGradient>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">{t0}{t1}{t2}<defs>{t3}{t4}<linearGradient id="paint2_linear_5666_4378" x1="17.4175" y1="15.8801" x2="17.4175" y2="22.5004" gradientUnits="userSpaceOnUse"><stop stopColor="#608DFF" /><stop offset="1" stopColor="#0046F8" /></linearGradient></defs></svg>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
export default AiIcon;